import { useMemo } from 'react';
import type { ScoreBarProps } from './types';
import { Counter } from './Counter';
import { PRESETS } from './presets';
import styles from './ScoreBar.module.css';

const ScoreBar = ({
  trending,
  teletekst,
  questionIndex,
  trendingColor,
  teletekstColor,
  trendingStrokeColor,
  teletekstStrokeColor,
  variant = 'inGame',
  style,
}: ScoreBarProps) => {
  const flipClass = useMemo(() => {
    if (questionIndex === undefined) return '';
    return questionIndex % 2 === 0 ? styles.flipEven : styles.flipOdd;
  }, [questionIndex]);

  const presetStyle = PRESETS[variant] as React.CSSProperties;

  return (
    <div
      className={`${styles.score} ${flipClass}`}
      style={{ ...presetStyle, ...style }}
    >
      <Counter value={trending} color={trendingColor} strokeColor={trendingStrokeColor} />
      <div className={styles.separator} />
      <Counter value={teletekst} color={teletekstColor} strokeColor={teletekstStrokeColor} />
    </div>
  );
};

export default ScoreBar;
